function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4.75,
  y: 11.1785,
  width: 14.5,
  height: 10.5,
  rx: 1.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4962 6.44359L15.4486 4.62906C14.2914 2.62478 11.7285 1.93807 9.72427 3.09524V3.09524C7.72 4.25241 7.03328 6.81526 8.19045 8.81953L9.23807 10.6341",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgUnlock = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnlock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Unlock.205bdd21.svg";
export { ForwardRef as ReactComponent };